import { API } from '@Providers';

export default async function (item: number) {
  const individualDiscount = true;

  const endpoint = `/api/shelter/cart/remove-item/${item}/${individualDiscount}`;

  return API({ endpoint });
}
